import {BasicModalProps} from "../../interfaces/BasicModalProps";
import {useState} from "react";
import client from "../../../../axios";
import {Modal} from "react-bootstrap";
import SecondaryButton from "../../atom/buttons/SecondaryButton";
import DangerButton from "../../atom/buttons/DangerButton";

interface DeleteCustomerModalProps extends BasicModalProps {
  deletingCusNo: string;
  getData(): void;
}

export default function DeleteCustomerModal(props: DeleteCustomerModalProps) {

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showAlreadyInUseModal, setShowAlreadyInUseModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  function handleCancel() {
    props.setShow(false);
  }

  async function handleDeleteCustomer() {
    if (props.deletingCusNo.length !== 0) {
      try {
        setIsDeleting(true);
        const res = await client.delete('/api/master/customer', { params: { cusNo: props.deletingCusNo } });
        props.setShow(false);

        setTimeout(() => {
          if (res.data.result === 'success') {
            setShowSuccessModal(true);
            props.getData();
          } else {
            setShowAlreadyInUseModal(true);
          }
        }, 200);
      } catch (e) {
        props.setShow(false);
        setTimeout(() => setShowErrorModal(true), 200);
      } finally {
        setIsDeleting(false);
      }
    }
  }

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          정말 삭제하시겠습니까?
        </Modal.Body>
        <Modal.Footer>
          <SecondaryButton onClick={handleCancel}>
            취소
          </SecondaryButton>
          <DangerButton onClick={handleDeleteCustomer} disabled={isDeleting}>
            삭제
          </DangerButton>
        </Modal.Footer>
      </Modal>

      <Modal show={showSuccessModal} centered>
        <Modal.Body>
          거래처를 성공적으로 삭제하였습니다.
        </Modal.Body>
        <Modal.Footer>
          <SecondaryButton onClick={() => setShowSuccessModal(false)}>
            닫기
          </SecondaryButton>
        </Modal.Footer>
      </Modal>

      <Modal show={showErrorModal} centered>
        <Modal.Body>
          거래처 삭제에 실패하였습니다.
        </Modal.Body>
        <Modal.Footer>
          <SecondaryButton onClick={() => setShowErrorModal(false)}>
            닫기
          </SecondaryButton>
        </Modal.Footer>
      </Modal>

      <Modal show={showAlreadyInUseModal} centered>
        <Modal.Body>
          이미 사용중인 거래처입니다.
        </Modal.Body>
        <Modal.Footer>
          <SecondaryButton onClick={() => setShowAlreadyInUseModal(false)}>
            닫기
          </SecondaryButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}